export default __webpack_public_path__ + "static/Flare-80cad328392f5e9df8295b1abd34408e.webm";